import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import { useCookies } from 'react-cookie';
import server from 'server/serverController2'
import LoginHeader from 'components/presenters/login/LoginHeader'
import LoginForm from 'components/presenters/login/LoginForm'
import CenterModal from 'components/presenters/modal/CenterModal'
import { isValidEmail, isValidPassword, getQueryStringObject } from 'utils/utils'
import { UserInfoActions, UserPermissionActions } from 'store/actionCreators'
import { sendWebViewMsg } from 'utils/bridge'
import useCreateOnboardingTodoMutate from 'hooks/queries/task/useCreateOnboardingTodoMutate'

const LoginContainer = () => {
  const [cookies, setCookie, removeCookie] = useCookies()
  const history = useHistory()
  // const userInfo = useSelector((state) => {
  //   return state.userInfo
  // })

  const queryString = getQueryStringObject()
  const redirectPath = queryString['redirect_path']

  const { mutateAsync: createOnboardingTodo } = useCreateOnboardingTodoMutate()

  // useEffect(() => {
  //   if (userInfo['isLogin']) {
  //     history.replace('/')
  //   }
  // }, [history, userInfo])
  const [isValid, setIsValid] = useState(false)
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [userInfoSetted, setUserInfoSetted] = useState(false)
  //Center Modal State
  const [initCenterModal, setInitCenterModal] = useState(false)
  const [centerModalVisible, setCenterModalVisible] = useState(false)
  const [centerModalDataList, setCenterModalDataList] = useState({})
  const [onModalComplete, setOnModalComplete] = useState(null)
  const [onModalCancel, setOnModalCancel] = useState(null)
  //Error
  const [emailError, setEmailError] = useState(null)
  const [passwordError, setPasswordError] = useState(null)

  useEffect(() => {
    if (userInfoSetted === true) {
      if (redirectPath && redirectPath.length > 0) {
        history.replace(redirectPath)
      } else {
        history.replace('/')
      }
    }
  }, [history, redirectPath, userInfoSetted])

  useEffect(() => {
    if (isValidEmail(email) && isValidPassword(password)) {
      setIsValid(true)
    } else {
      setIsValid(false)
    }
  }, [email, password])

  //Init Center Modal State
  useEffect(() => {
    if (initCenterModal === true) {
      setCenterModalVisible(false)
      setCenterModalDataList({})
      setOnModalComplete(null)
      setOnModalCancel(null)
      setInitCenterModal(false)
    }
  }, [initCenterModal])

  const handleValueChange = (value) => {
    if (value['email']) {
      if (isValidEmail(value['email']) || value['email'].length === 0) {
        setEmailError(null)
      } else {
        setEmailError('이메일 형식이 올바르지 않습니다')
      }
      setEmail(value['email'])
    } else if (value['password']) {
      if (!isValidPassword(value['password']) && value['password'].length !== 0) {
        setPasswordError('비밀번호는 영문, 숫자, 특수문자 포함 8자 이상으로 설정해 주세요')
      } else {
        setPasswordError(null)
      }
      setPassword(value['password'])
    }
  }
  const handleRequestLogin = () => {
    const form = {}
    form['email'] = email
    form['password'] = password
    server.postRequestData(`auth/signin`, form, async (res) => {
      if (res?.success !== 1) {
        let errData = res.error.res_data
        setCenterModalVisible(true)
        if (errData['detail_code'] === 'LOGIN_ERR_CHECK_EMAIL_PASSWORD') {
          setCenterModalDataList({ description: '이메일/비밀번호를 확인해주세요' })
          setOnModalComplete(() => () => {
            setInitCenterModal(true)
          })
        } else if (errData['detail_code'] === 'INACTIVATED_ACCOUNT') {
          setCenterModalDataList({
            description: '비활성화된 계정입니다. admin@unitmi.com으로 문의해주세요.',
          })
          setOnModalComplete(() => () => {
            setInitCenterModal(true)
          })
        } else {
          setCenterModalDataList({
            description: '로그인에 실패하였습니다. 추후 다시 시도해주세요.',
          })
          setOnModalComplete(() => () => {
            setInitCenterModal(true)
          })
        }
        //err handling
        return
      }
      const jsonData = res['data']
      const userData = jsonData['user']
      const permissionData = jsonData['permissions']
      UserInfoActions.updateUserState({
        name: userData.nickname,
        email: userData.email,
        id: userData.no,
        isLogin: true,
        achievement_goal: userData.achievement_goal,
        profile_img: userData.profile_img,
        exp_point: userData.exp_point,
      })
      UserInfoActions.updateRole({
        role: userData['role'],
      })
      if (permissionData) {
        UserPermissionActions.updateUserPermission({ matching: permissionData['matching'] })
      }

      if (cookies['onboarding_habit']
        && cookies['onboarding_description'] !== undefined
        && cookies['onboarding_original_image_name']
        && cookies['onboarding_original_image_path']
        && cookies['onboarding_merged_image_name']
        && cookies['onboarding_merged_image_path']
      ) {
        try {
          await createOnboardingTodo({
            onboardingType: cookies['onboarding_habit'],
            description: cookies['onboarding_description'],
            originalImageName: cookies['onboarding_original_image_name'],
            originalImagePath: cookies['onboarding_original_image_path'],
            mergedImageName: cookies['onboarding_merged_image_name'],
            mergedImagePath: cookies['onboarding_merged_image_path'],
          })

          removeCookie('onboarding_habit', { path: '/' })
          removeCookie('onboarding_description', { path: '/' })
          removeCookie('onboarding_original_image_name', { path: '/' })
          removeCookie('onboarding_original_image_path', { path: '/' })
          removeCookie('onboarding_merged_image_name', { path: '/' })
          removeCookie('onboarding_merged_image_path', { path: '/' })

        } catch (e) {
          setCenterModalVisible(true)
          setCenterModalDataList({
            description: '3일 챌린지 인증기록을 저장하지 못했어요.\n카카오로 문의 주시면 해결해 드릴게요.',
            confirmTxt: '문의하기',
          })
          setOnModalComplete(() => () => {
            setInitCenterModal(true)
            window.open('https://pf.kakao.com/_gmtJs/chat', '_blank')
          })
          setOnModalCancel(()=> () => {
            setInitCenterModal(true)
          })
          return
        }
      }

      setUserInfoSetted(true)
      setCookie('is_onboarding_completed', 'true', { path: '/', maxAge: 60 * 60 * 24 * 365 })
      sendWebViewMsg({ action: 'REQ_COOKIE_FLUSH' })
    })
  }

  return (
    <LoginContainerBlock>
      <LoginHeader />
      <LoginForm
        redirectPath={redirectPath}
        isValid={isValid}
        onChange={handleValueChange}
        onSubmit={handleRequestLogin}
        emailError={emailError}
        passwordError={passwordError}
      />
      <CenterModal
        modalVisible={centerModalVisible}
        setModalVisible={setCenterModalVisible}
        dataList={centerModalDataList}
        onCancel={onModalCancel}
        onComplete={onModalComplete}
      />
    </LoginContainerBlock>
  )
}

const LoginContainerBlock = styled.div`
  padding: calc(100vw * (51 / 375)) calc(100vw * (30 / 375)) calc(100vw * (28 / 375))
    calc(100vw * (30 / 375));
`

export default LoginContainer
